import { render } from "./ButtonSubmit.vue?vue&type=template&id=555b430a&ts=true"
import script from "./ButtonSubmit.vue?vue&type=script&lang=ts"
export * from "./ButtonSubmit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__